import React from 'react';
import { Link } from "react-router-dom";
import styles from "../styles/about.module.css"

export default function About() {
    return (
        <div className={styles.about_container}>
            <div className={styles.about_content}>
                <h1>Dog Breeds App</h1>
                <div className={styles.about_first}>
                    <p>
                        It is an application where you can observe different breeds of dogs, you will have the opportunity to create your own breed.
                        You will be able to sort them alphabetically, by weight, as well as the breeds created and those that are not, you will be able to filter by temperaments. In addition, you will have a search bar to find a specific one
                        and finally you will be able to see all the information corresponding to a specific breed.
                    </p>
                    <div>
                        <span>see this project on</span>
                        <button>
                            <i class="bi bi-github" />
                            <br />
                            <a href="#">github</a>
                        </button>
                    </div>
                </div>
                <div className={styles.about_second}>
                    <p>
                        Hi, I'm Andres.
                        I am a full stack web developer, creator of this project and I would like to tell you a little about this project
                        this project is part of the intensive training of Bootcamp Henry;
                        where the idea is to put into practice both technical and soft skills acquired during it.
                    </p>
                    <div>
                        <span>Follow me on</span>
                        <button>
                            <i class="bi bi-github"></i>
                            <br />
                            <a href="#">github</a>
                        </button>
                        <button>
                            <i class="bi bi-linkedin"></i>
                            <br />
                            <a href="#">Linkedin</a>
                        </button>
                    </div>
                </div>
                <span>thanks for seeing </span>
                <div className={styles.btn_landing_home}>
                    <Link to={'/'}>
                        <span className={styles.enter_out}>landing</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}